<template>
    <div>
        <div v-if="Math.floor(Math.random() * 3) === 0">
            <a href="https://prf.hn/click/camref:1101l55yCo/destination:https://www.ii.co.uk/ii-accounts/isa" target="_blank">
              <img class="img-partner" src="/img/banner/DisplayStatic_ISA_August.png" alt="AffiliateStatic_ISA">
            </a>
          </div>
          <div v-else-if="Math.floor(Math.random() * 3) === 1">
            <a href="https://prf.hn/click/camref:1101l55yCo/destination:https://www.ii.co.uk/ii-accounts/sipp" target="_blank">
              <img class="img-partner" src="/img/banner/DisplayStatic_SIPP_August.png" alt="AffiliateStatic_SIPP">
            </a>
          </div>
          <div v-else>
            <a href="https://prf.hn/click/camref:1101l55yCo/destination:https://www.ii.co.uk/ii-accounts/trading-account" target="_blank">
              <img class="img-partner" src="/img/banner/DisplayStatic_GIA_August.png" alt="AffiliateStatic_GIA">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdsPartner',
}
</script>
<style>
.img-partner {
    max-height: calc(100vh - 100px);
}
.columns {
    position: relative;
}
@media (min-width: 769px) {
    .is-scroll-top .banner-on-top {
        position: sticky !important;
        top: 60px !important;
    }
}
</style>